<template>
  <div>

    <CostMasterModal
        v-if="!loading && masterModal"
        ref="master-modal"
        emit-only
        :show-nav="false"
        :show-options="false"
        :cost-id="parseInt(costId)"
        :stage="masterModal"
        @close="closeCostsModal"
        @cost-edited="onCostEdited"
    />
    
    <TitleBar>
        <template v-slot:title><translate>Balance Sheet Investments</translate></template>
        <template v-slot:buttons>
            <OnboardingIntroLink :onboarding-intro="'onboarding_web_investments'" />
            <GekkoButton 
                v-if="!$route.path.includes('control-panel')"
                @click="goToFinancialReporting()" 
                :text="$gettext('Financial Statements')" 
                icon="fa-solid fa-arrow-up-right-from-square"
                :icon-right="true"
                variant="link"
                class="mr-2"
            />
            <GekkoButton 
                @click="addInvestmentItem()" 
                :text="$gettext('New investment')" 
                icon="fa-solid fa-plus"
                class="m-2"
            />
            <b-dropdown class="icon-toggle ui-dashboard-menu-dropdown" variant="outline-primary" right no-caret>
                <template #button-content>
                    <font-awesome-icon icon="fa-solid fa-ellipsis-vertical" />
                </template>
                <b-dropdown-item v-if="!$route.path.includes('control-panel')" @click="addCostCategory()">
                    <font-awesome-icon icon="fa-solid fa-cart-shopping" />
                    <span v-translate>Add cost type</span>
                </b-dropdown-item>
                <b-dropdown-item @click="download()">
                    <font-awesome-icon icon="fa-solid fa-download" />
                    <span v-translate>Download</span>
                </b-dropdown-item>
            </b-dropdown>
        </template>
    </TitleBar>
    <div class="content balancesheet">
        <BalanceSheetTable ref="balancesheettable" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import { promptDownload } from "@/utils/"

import CostService from "@/store/services/cost.service.js"

import TitleBar from "@/components/TitleBar";
import GekkoButton from "@/components/GekkoButton";
import BalanceSheetTable from '@/components/balance_sheet/BalanceSheetTable.vue';
import OnboardingIntroLink from "@/components/ui/OnboardingIntroLink";

import CostMasterModal from "@/components/costs/CostMasterModal"


export default {
    name: 'BalanceSheet',
    components: { GekkoButton, TitleBar, BalanceSheetTable, OnboardingIntroLink, CostMasterModal },
    data () {
        return {
            loading: true,
            masterModal: null,
            costId: null,
        }
    },
    computed: {
        ...mapGetters ({
            currentUser: "main/getCurrentUser",
            getCompanyId: 'main/getCompanyId'
        })
    },
    watch: {
        $route: {
        immediate: true,
        handler (to) {
            this.masterModal = to.meta.masterModal
            this.costId = this.$route.params['costId']

            if (this.masterModal) {
                document.body.classList.add('master-modal-on')
            } else {
                document.body.classList.remove('master-modal-on')
            }
        }
        },
    },
    beforeRouteLeave (to, from, next) {
        if (from.name === "BalanceSheet" && this.$refs.balancesheettable && this.$refs.balancesheettable.editedRowId) {
            if (to.name !== "CostTypes" && to.name !== "BalanceSheetEditCost" && to.name !== "AddInvestmentItem" && to.name !== "EditInvestmentItem") {
                    const ConfirmModalConstructor = this.$options.components['confirm-modal']
                    const confirmModalInstance = new ConfirmModalConstructor({ propsData: {
                        title: this.$gettext('Leaving this page'),
                        message: this.$gettext(`Changes you made may not be saved. Do you still want to navigate to ` + to.name + '?'),
                        options: {
                            variant: 'primary',
                            confirmText: this.$gettext('Ok')
                        }
                    }})
                    confirmModalInstance.$mount()
                    document.body.appendChild(confirmModalInstance.$el)
                    confirmModalInstance.$on('confirmed', () => {
                        if (confirmModalInstance && confirmModalInstance.$el.parentNode) {
                            confirmModalInstance.$el.parentNode.removeChild(confirmModalInstance.$el)
                        }
                        next()
                    })
                    confirmModalInstance.$on('cancel', () => {
                        if (confirmModalInstance && confirmModalInstance.$el.parentNode) {
                            confirmModalInstance.$el.parentNode.removeChild(confirmModalInstance.$el)
                        }
                    })
            }
        } else {
            next()
        }
    },
    created () {
        window.onbeforeunload = this.onWindowClose;
        this.loadCostsGlobalData().then(() => {
            this.loading = false
        })
    },
    destroyed () {
        window.onbeforeunload = null;
    },
    methods: {
        ...mapActions ({
            loadCostsGlobalData: 'costs/loadCostsGlobalData'
        }),
        addInvestmentItem() {
            var isPremium = this.$store.getters['getIsPremium'];
            if (isPremium || this.currentUser.is_accountant)
                this.$router.push({name: 'AddInvestmentItem'});
            else
                this.$store.commit('togglePremiumModal', 'web_reporting_investments');
        },
        download () {
           CostService.getInvestmentsPDFBlob({ company_profile: this.getCompanyId }).then(response => {
                promptDownload(response)
            }).catch(error => console.error('Error downloading PDF:', error));
        },
        addCostCategory() {
            this.$router.push({ name: 'CostTypes' });
        },
        areRowsEdited() {
            return true;
        },
        onWindowClose() {
            if (this.$refs.balancesheettable.editedRowId) {
                return true;
            }
        },
        goToFinancialReporting() {
            this.$router.push({ name: 'FinancialStatements' }).catch(() => {})
        },
        closeCostsModal () {
            this.masterModal = null
            this.$router.push({ name: 'BalanceSheet' }).catch(() => {})
        },
        onCostEdited () {
            this.$refs.balancesheettable.refreshData()
            this.$router.push({ name: 'BalanceSheet' }).catch(() => {})
        }
    }
}
</script>

<style lang="scss">

</style>